import { isNotNullObject } from '../src/helpers/ObjectHelpers';

export default class {
  static get(key, accessor = null) {
    const item = localStorage.getItem(key);

    try {
      const object = JSON.parse(item);

      return accessor ? _.get(object, accessor) : object;
    } catch (e) {
      return item;
    }
  }


  static set(key, value) {
    localStorage.setItem(key, isNotNullObject(value) ? JSON.stringify(value) : value);
  }


  static delete(key) {
    localStorage.removeItem(key);
  }
}
